import React from "react";
import Navbar from "../components/Navbar";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />

      <div className="max-w-4xl mx-auto px-6 py-20">
        <h1 className="text-4xl text-[#FFD700] font-['Cinzel'] mb-10">
          Privacy Policy
        </h1>

        <div className="space-y-6 text-gray-300 leading-relaxed">
          <p>
            TopNationApp respects your privacy and is committed to protecting your
            personal data.
          </p>

          <p>
            This Privacy Policy explains how we collect, use, and protect your
            information when you use the TopNationApp platform.
          </p>

          <h2 className="text-xl text-[#FFD700] mt-6">Information We Collect</h2>

          <p>
            When you register and use the platform we may collect the following information:
          </p>

          <ul className="list-disc ml-6 space-y-2">
            <li>Email address used for account registration</li>
            <li>User account identification data</li>
            <li>Bid information related to countries</li>
            <li>Public profile name, company name, website, or custom display name entered by the user</li>
          </ul>

          <h2 className="text-xl text-[#FFD700] mt-6">Public Information</h2>

          <p>
            Any public profile name, company name, website, or custom display name you enter may become publicly visible on the world map, country pages, rankings, and leaderboard areas of the platform.
          </p>

          <h2 className="text-xl text-[#FFD700] mt-6">Payments</h2>

          <p>
            Payments on TopNationApp are securely processed by Stripe. We do not store your payment card details.
          </p>

          <h2 className="text-xl text-[#FFD700] mt-6">Data Protection</h2>

          <p>
            We take reasonable security measures to protect your information and prevent unauthorized access or misuse of the platform.
          </p>

          <h2 className="text-xl text-[#FFD700] mt-6">Contact</h2>

          <p>
            If you have questions regarding this Privacy Policy you may contact the platform operator through the official communication channels.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
